/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlytzcollectAnalyticsRouteImport } from './routes/blytzcollect/analytics'
import { Route as CsToolsAutopayAccountsRouteImport } from './routes/cs-tools/autopay-accounts'
import { Route as CsToolsMerchantNotesRouteImport } from './routes/cs-tools/merchant-notes'
import { Route as CsToolsMessageReportRouteImport } from './routes/cs-tools/message-report'
import { Route as CsToolsOptOutsRouteImport } from './routes/cs-tools/opt-outs'
import { Route as CsToolsPaymentReportRouteImport } from './routes/cs-tools/payment-report'
import { Route as CsToolsReconciliationRouteImport } from './routes/cs-tools/reconciliation'
import { Route as CsToolsRegistrationsRouteImport } from './routes/cs-tools/registrations'
import { Route as CsToolsUndeliveredRouteImport } from './routes/cs-tools/undelivered'
import { Route as LabReportChatRouteImport } from './routes/lab/report-chat'
import { Route as LabReportDraftRouteImport } from './routes/lab/report-draft'
import { Route as LabReportDraftsRouteImport } from './routes/lab/report-drafts'
import { Route as PaymentsAchReturnsRouteImport } from './routes/payments/ach-returns'
import { Route as PaymentsBinMccFeeReportRouteImport } from './routes/payments/bin-mcc-fee-report'
import { Route as PaymentsMulticardUsageRouteImport } from './routes/payments/multicard-usage'
import { Route as ReportsAiTextsRouteImport } from './routes/reports/ai-texts'
import { Route as ReportsMerchantSettingsRouteImport } from './routes/reports/merchant-settings'
import { Route as ReportsRetryAnalysisRouteImport } from './routes/reports/retry-analysis'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectAnalyticsRoute = BlytzcollectAnalyticsRouteImport.update({
  id: '/blytzcollect/analytics',
  path: '/blytzcollect/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsAutopayAccountsRoute = CsToolsAutopayAccountsRouteImport.update({
  id: '/cs-tools/autopay-accounts',
  path: '/cs-tools/autopay-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMerchantNotesRoute = CsToolsMerchantNotesRouteImport.update({
  id: '/cs-tools/merchant-notes',
  path: '/cs-tools/merchant-notes',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMessageReportRoute = CsToolsMessageReportRouteImport.update({
  id: '/cs-tools/message-report',
  path: '/cs-tools/message-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsOptOutsRoute = CsToolsOptOutsRouteImport.update({
  id: '/cs-tools/opt-outs',
  path: '/cs-tools/opt-outs',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsPaymentReportRoute = CsToolsPaymentReportRouteImport.update({
  id: '/cs-tools/payment-report',
  path: '/cs-tools/payment-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsReconciliationRoute = CsToolsReconciliationRouteImport.update({
  id: '/cs-tools/reconciliation',
  path: '/cs-tools/reconciliation',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsRegistrationsRoute = CsToolsRegistrationsRouteImport.update({
  id: '/cs-tools/registrations',
  path: '/cs-tools/registrations',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsUndeliveredRoute = CsToolsUndeliveredRouteImport.update({
  id: '/cs-tools/undelivered',
  path: '/cs-tools/undelivered',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportChatRoute = LabReportChatRouteImport.update({
  id: '/lab/report-chat',
  path: '/lab/report-chat',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportDraftRoute = LabReportDraftRouteImport.update({
  id: '/lab/report-draft',
  path: '/lab/report-draft',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportDraftsRoute = LabReportDraftsRouteImport.update({
  id: '/lab/report-drafts',
  path: '/lab/report-drafts',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsAchReturnsRoute = PaymentsAchReturnsRouteImport.update({
  id: '/payments/ach-returns',
  path: '/payments/ach-returns',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsBinMccFeeReportRoute = PaymentsBinMccFeeReportRouteImport.update({
  id: '/payments/bin-mcc-fee-report',
  path: '/payments/bin-mcc-fee-report',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsMulticardUsageRoute = PaymentsMulticardUsageRouteImport.update({
  id: '/payments/multicard-usage',
  path: '/payments/multicard-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsAiTextsRoute = ReportsAiTextsRouteImport.update({
  id: '/reports/ai-texts',
  path: '/reports/ai-texts',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsMerchantSettingsRoute = ReportsMerchantSettingsRouteImport.update({
  id: '/reports/merchant-settings',
  path: '/reports/merchant-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRetryAnalysisRoute = ReportsRetryAnalysisRouteImport.update({
  id: '/reports/retry-analysis',
  path: '/reports/retry-analysis',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/reports/ai-texts': typeof ReportsAiTextsRoute
  '/reports/merchant-settings': typeof ReportsMerchantSettingsRoute
  '/reports/retry-analysis': typeof ReportsRetryAnalysisRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/reports/ai-texts': typeof ReportsAiTextsRoute
  '/reports/merchant-settings': typeof ReportsMerchantSettingsRoute
  '/reports/retry-analysis': typeof ReportsRetryAnalysisRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/reports/ai-texts': typeof ReportsAiTextsRoute
  '/reports/merchant-settings': typeof ReportsMerchantSettingsRoute
  '/reports/retry-analysis': typeof ReportsRetryAnalysisRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-report'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/undelivered'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/reports/ai-texts'
    | '/reports/merchant-settings'
    | '/reports/retry-analysis'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-report'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/undelivered'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/reports/ai-texts'
    | '/reports/merchant-settings'
    | '/reports/retry-analysis'
  id:
    | '__root__'
    | '/'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-report'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/undelivered'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/reports/ai-texts'
    | '/reports/merchant-settings'
    | '/reports/retry-analysis'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlytzcollectAnalyticsRoute: typeof BlytzcollectAnalyticsRoute
  CsToolsAutopayAccountsRoute: typeof CsToolsAutopayAccountsRoute
  CsToolsMerchantNotesRoute: typeof CsToolsMerchantNotesRoute
  CsToolsMessageReportRoute: typeof CsToolsMessageReportRoute
  CsToolsOptOutsRoute: typeof CsToolsOptOutsRoute
  CsToolsPaymentReportRoute: typeof CsToolsPaymentReportRoute
  CsToolsReconciliationRoute: typeof CsToolsReconciliationRoute
  CsToolsRegistrationsRoute: typeof CsToolsRegistrationsRoute
  CsToolsUndeliveredRoute: typeof CsToolsUndeliveredRoute
  LabReportChatRoute: typeof LabReportChatRoute
  LabReportDraftRoute: typeof LabReportDraftRoute
  LabReportDraftsRoute: typeof LabReportDraftsRoute
  PaymentsAchReturnsRoute: typeof PaymentsAchReturnsRoute
  PaymentsBinMccFeeReportRoute: typeof PaymentsBinMccFeeReportRoute
  PaymentsMulticardUsageRoute: typeof PaymentsMulticardUsageRoute
  ReportsAiTextsRoute: typeof ReportsAiTextsRoute
  ReportsMerchantSettingsRoute: typeof ReportsMerchantSettingsRoute
  ReportsRetryAnalysisRoute: typeof ReportsRetryAnalysisRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/analytics': {
      id: '/blytzcollect/analytics'
      path: '/blytzcollect/analytics'
      fullPath: '/blytzcollect/analytics'
      preLoaderRoute: typeof BlytzcollectAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/autopay-accounts': {
      id: '/cs-tools/autopay-accounts'
      path: '/cs-tools/autopay-accounts'
      fullPath: '/cs-tools/autopay-accounts'
      preLoaderRoute: typeof CsToolsAutopayAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/merchant-notes': {
      id: '/cs-tools/merchant-notes'
      path: '/cs-tools/merchant-notes'
      fullPath: '/cs-tools/merchant-notes'
      preLoaderRoute: typeof CsToolsMerchantNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/message-report': {
      id: '/cs-tools/message-report'
      path: '/cs-tools/message-report'
      fullPath: '/cs-tools/message-report'
      preLoaderRoute: typeof CsToolsMessageReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/opt-outs': {
      id: '/cs-tools/opt-outs'
      path: '/cs-tools/opt-outs'
      fullPath: '/cs-tools/opt-outs'
      preLoaderRoute: typeof CsToolsOptOutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/payment-report': {
      id: '/cs-tools/payment-report'
      path: '/cs-tools/payment-report'
      fullPath: '/cs-tools/payment-report'
      preLoaderRoute: typeof CsToolsPaymentReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/reconciliation': {
      id: '/cs-tools/reconciliation'
      path: '/cs-tools/reconciliation'
      fullPath: '/cs-tools/reconciliation'
      preLoaderRoute: typeof CsToolsReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/registrations': {
      id: '/cs-tools/registrations'
      path: '/cs-tools/registrations'
      fullPath: '/cs-tools/registrations'
      preLoaderRoute: typeof CsToolsRegistrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/undelivered': {
      id: '/cs-tools/undelivered'
      path: '/cs-tools/undelivered'
      fullPath: '/cs-tools/undelivered'
      preLoaderRoute: typeof CsToolsUndeliveredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-chat': {
      id: '/lab/report-chat'
      path: '/lab/report-chat'
      fullPath: '/lab/report-chat'
      preLoaderRoute: typeof LabReportChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-draft': {
      id: '/lab/report-draft'
      path: '/lab/report-draft'
      fullPath: '/lab/report-draft'
      preLoaderRoute: typeof LabReportDraftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-drafts': {
      id: '/lab/report-drafts'
      path: '/lab/report-drafts'
      fullPath: '/lab/report-drafts'
      preLoaderRoute: typeof LabReportDraftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/ach-returns': {
      id: '/payments/ach-returns'
      path: '/payments/ach-returns'
      fullPath: '/payments/ach-returns'
      preLoaderRoute: typeof PaymentsAchReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/bin-mcc-fee-report': {
      id: '/payments/bin-mcc-fee-report'
      path: '/payments/bin-mcc-fee-report'
      fullPath: '/payments/bin-mcc-fee-report'
      preLoaderRoute: typeof PaymentsBinMccFeeReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/multicard-usage': {
      id: '/payments/multicard-usage'
      path: '/payments/multicard-usage'
      fullPath: '/payments/multicard-usage'
      preLoaderRoute: typeof PaymentsMulticardUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/ai-texts': {
      id: '/reports/ai-texts'
      path: '/reports/ai-texts'
      fullPath: '/reports/ai-texts'
      preLoaderRoute: typeof ReportsAiTextsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/merchant-settings': {
      id: '/reports/merchant-settings'
      path: '/reports/merchant-settings'
      fullPath: '/reports/merchant-settings'
      preLoaderRoute: typeof ReportsMerchantSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/retry-analysis': {
      id: '/reports/retry-analysis'
      path: '/reports/retry-analysis'
      fullPath: '/reports/retry-analysis'
      preLoaderRoute: typeof ReportsRetryAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlytzcollectAnalyticsRoute: BlytzcollectAnalyticsRoute,
  CsToolsAutopayAccountsRoute: CsToolsAutopayAccountsRoute,
  CsToolsMerchantNotesRoute: CsToolsMerchantNotesRoute,
  CsToolsMessageReportRoute: CsToolsMessageReportRoute,
  CsToolsOptOutsRoute: CsToolsOptOutsRoute,
  CsToolsPaymentReportRoute: CsToolsPaymentReportRoute,
  CsToolsReconciliationRoute: CsToolsReconciliationRoute,
  CsToolsRegistrationsRoute: CsToolsRegistrationsRoute,
  CsToolsUndeliveredRoute: CsToolsUndeliveredRoute,
  LabReportChatRoute: LabReportChatRoute,
  LabReportDraftRoute: LabReportDraftRoute,
  LabReportDraftsRoute: LabReportDraftsRoute,
  PaymentsAchReturnsRoute: PaymentsAchReturnsRoute,
  PaymentsBinMccFeeReportRoute: PaymentsBinMccFeeReportRoute,
  PaymentsMulticardUsageRoute: PaymentsMulticardUsageRoute,
  ReportsAiTextsRoute: ReportsAiTextsRoute,
  ReportsMerchantSettingsRoute: ReportsMerchantSettingsRoute,
  ReportsRetryAnalysisRoute: ReportsRetryAnalysisRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
